

import { AxiosError } from "axios";
import { toast } from "sonner";

export function useInventaireErrorHandler() {
  const handleError = (error: unknown) => {
    let errorMessage = "Une erreur est survenue lors de l'opération.";

    if (error instanceof AxiosError) {
      const responseData = error.response?.data;

      // Vérifier si c'est une erreur de limite d'usage (403 Forbidden)
      if (error.response?.status === 403 || error.response?.status === 400) {
        const message = responseData?.message || error.message || responseData?.error;

        // Détecter les erreurs de limite
        if (
          message?.includes("Limite") ||
          message?.includes("atteinte") ||
          message?.includes("abonnement") ||
          message?.includes("requis") ||
          message?.includes("mensuelle")
        ) {
          errorMessage = message;
          // Afficher le message d'erreur dans un toast
          toast.error(errorMessage, {
            duration: 5000,
          });
          return;
        }
      }

      // Pour les autres erreurs, utiliser le message de l'API si disponible
      if (responseData?.message) {
        errorMessage = responseData.message;
      } else if (responseData?.error) {
        errorMessage = responseData.error;
      } else if (error.message) {
        errorMessage = error.message;
      }
    } else if (error instanceof Error) {
      errorMessage = error.message;
    }

    // Afficher le toast même pour les autres erreurs liées aux limites
    if (
      errorMessage.includes("Limite") ||
      errorMessage.includes("atteinte") ||
      errorMessage.includes("abonnement") ||
      errorMessage.includes("requis")
    ) {
      toast.error(errorMessage, {
        duration: 5000,
      });
    }
  };

  return {
    handleError,
  };
}
